<div *ngIf="subtitle" class="subtitle" [innerHtml]="subtitle"></div>
<div
	*ngIf="subtitleNote"
	class="subtitle-note"
	[innerHtml]="subtitleNote"
></div>
<div class="price" *ngIf="price !== undefined">
	<price
		*ngIf="price !== 0 || (price === 0 && displayZeroPrice)"
		[value]="price"
		[beforeText]="beforePriceText"
		[afterText]="afterPriceText"
		[settings]="_settings"
	></price>
</div>
<div class="price" *ngIf="!!priceText">
	<div class="price-text" [innerHTML]="priceText"></div>
</div>
